import request from '@/utils/request'

export function getSafetyManagerManageMaster(param, isNotify) {
  return request({
    url: `/api/getSafetyManagerManageMaster`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'searched' },
  })
}

export function getOrgnOrder(param, isNotify) {
  return request({
    url: `/api/getOrgnOrder`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'searched' },
  })
}

export function getSafetyManagerManageDetail(param, isNotify) {
  return request({
    url: `/api/getSafetyManagerManageDetail`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'searched' },
  })
}

export function saveSafetyManagerManage(param, isNotify) {
  return request({
    url: `/api/saveSafetyManagerManage`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'saved' },
  })
}

export function deleteSafetyManagerManage(param, isNotify) {
  return request({
    url: `/api/deleteSafetyManagerManage`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'deleted' },
  })
}

export function getSafetyManagerManageDataDiv(param, isNotify) {
  return request({
    url: `/api/getSafetyManagerManageDataDiv`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'searched' },
  })
}

export function addSafetyManagerManageDataDiv(param, isNotify) {
  return request({
    url: `/api/addSafetyManagerManageDataDiv`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'saved' },
  })
}

export function applySafetyManagerManageDataDiv(param, isNotify) {
  return request({
    url: `/api/applySafetyManagerManageDataDiv`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'saved' },
  })
}

export function copySafetyManagerManageDataDiv(param, isNotify) {
  return request({
    url: `/api/copySafetyManagerManageDataDiv`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'saved' },
  })
}

export function saveSafetyManagerManageDataDiv(param, isNotify) {
  return request({
    url: `/api/saveSafetyManagerManageDataDiv`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'saved' },
  })
}

export function deleteSafetyManagerManageDataDiv(param, isNotify) {
  return request({
    url: `/api/deleteSafetyManagerManageDataDiv`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'deleted' },
  })
}

export function saveSafetyManagerManageAuthDiv(param, isNotify) {
  return request({
    url: `/api/saveSafetyManagerManageAuthDiv`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'saved' },
  })
}

export function deleteSafetyManagerManageAuthDiv(param, isNotify) {
  return request({
    url: `/api/deleteSafetyManagerManageAuthDiv`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'deleted' },
  })
}

export function getSafetyManagerManageAuthDivItem(param, isNotify) {
  return request({
    url: `/api/getSafetyManagerManageAuthDivItem`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'searched' },
  })
}

export function saveSafetyManagerManageAuthDivItem(param, isNotify) {
  return request({
    url: `/api/saveSafetyManagerManageAuthDivItem`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'saved' },
  })
}

export function deleteSafetyManagerManageAuthDivItem(param, isNotify) {
  return request({
    url: `/api/deleteSafetyManagerManageAuthDivItem`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'deleted' },
  })
  
}

export function getRptSafetyManage (params, isProgress) {
  let responseType = "blob"
  return request({
    url: `/api/getRptSafetyManage`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    responseType: responseType,
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' },
  })
}